(() => {
  if (window.spProductHeaderPerformanceInitialized) return;
  window.spProductHeaderPerformanceInitialized = true;

  const mobileQuery = window.matchMedia('(max-width: 640px)');
  const titleCache = new WeakMap();
  const boundTitles = new WeakSet();
  let scheduled = false;
  let fontRevision = 0;

  function fitTitle(title) {
    const width = title.clientWidth;
    if (!width) return;
    const isMobile = mobileQuery.matches;
    const text = title.textContent;
    const previous = titleCache.get(title);
    if (previous && previous.width === width && previous.text === text && previous.isMobile === isMobile && previous.fontRevision === fontRevision) return;
    const maximum = isMobile ? 22 : 28;
    const minimum = isMobile ? 15 : 18;
    let size = maximum;
    title.style.fontSize = `${size}px`;
    title.style.lineHeight = '1.12';
    title.style.webkitLineClamp = 'unset';
    while (size > minimum) {
      const lineHeight = Number.parseFloat(getComputedStyle(title).lineHeight);
      if (title.scrollHeight <= lineHeight * 3 + 1) break;
      size -= 0.5;
      title.style.fontSize = `${size}px`;
    }
    title.style.webkitLineClamp = '3';
    titleCache.set(title, {width, text, isMobile, fontRevision});
    const wrapper = title.closest('.product-block-list__wrapper');
    const rating = wrapper?.querySelector('[data-sp-loox-rating-block] .loox-rating, [data-sp-loox-rating-block] a[href="#looxReviews"], .product-meta__reviews-badge');
    if (rating) {
      const scale = Math.max(isMobile ? 0.82 : 0.88, Math.min(1, size / maximum));
      rating.style.display = 'inline-block';
      rating.style.transformOrigin = 'left center';
      rating.style.transform = `scale(${scale})`;
    }
  }

  const resizeObserver = new ResizeObserver(schedule);

  function update() {
    scheduled = false;
    document.querySelectorAll('section[data-section-type="product"] .product-meta__title').forEach((title) => {
      if (!boundTitles.has(title)) {
        boundTitles.add(title);
        resizeObserver.observe(title);
      }
      fitTitle(title);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  function initialize() {
    document.querySelectorAll('section[data-section-type="product"]').forEach((section) => {
      const observer = new MutationObserver((records) => {
        if (records.some((record) => Array.from(record.addedNodes).some((node) =>
          node instanceof Element && (node.matches('.product-meta__title') || node.querySelector('.product-meta__title'))
        ))) schedule();
      });
      observer.observe(section, {childList: true, subtree: true});
    });
    schedule();
  }

  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('product:rerender', schedule);
  mobileQuery.addEventListener('change', schedule);
  if (document.fonts) {
    const updateFonts = () => { fontRevision += 1; schedule(); };
    document.fonts.ready.then(updateFonts);
    document.fonts.addEventListener('loadingdone', updateFonts);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();
